import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useSearchParams, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const contractorAccess = [
    "/",
    "/daily",
    "/weekly",
    "/account",
    "/cleandetail",
    "/completeclean",
    "/searchresult",
    "/uploadimage"
];

// For routes that can only be accessed by authenticated users
function AuthGuard ({ children }) {
    const { user, signInByAuthCode, isInit } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [isVaildToken, setIsVaildToken] = useState(false);

    useEffect(() => {
        vaildToken();
    }, []);

    useEffect(() => {
        if (isVaildToken && isInit) {
            if (!user) {
                navigate("/login");
            }

            if (user?.role === "Contractor" && !contractorAccess.includes(location?.pathname?.toLowerCase() ?? '/')) {
                navigate("/Page401");
            }
        }
    }, [isVaildToken, isInit]);

    const vaildToken = async () => {
        if (token) {
            try {
                await signInByAuthCode(token);
            } catch { }
        }
        setIsVaildToken(true);
    }

    return (
        <>
            {
                isVaildToken && <React.Fragment>{children}</React.Fragment>
            }
        </>
    );
}

export default AuthGuard;
